export default "__VITE_ASSET__AfLmTDuS__"